/**
 * The minimized workspace floating chat: the shared FloatingChat FAB pinned
 * inside the layout's content region (not viewport-fixed) so it respects the
 * left rail / right pane like the rest of the surface. The workspace twin of
 * `CanvasChatFab` (no onboarding target, no container-query escape — the
 * region isn't a CSS `@container`). See `FloatingChatFab` for the shell
 * behavior (activity pulse, left-dock `dockStyle` escape).
 */
import { FloatingChatFab } from "@/components/FloatingChat/FloatingChatFab";
import type { CSSProperties } from "react";

export function WorkspaceChatFab({
  onOpen,
  running,
  dockStyle,
}: {
  onOpen: () => void;
  /** A run is in progress — pulse the launcher so activity isn't missed. */
  running: boolean;
  /**
   * When set, the launcher pins to the LEFT (viewport-fixed) instead of the
   * region's bottom-right — used while a full-width detail pane occupies the
   * right. The caller computes the geometry from the content-region rect.
   */
  dockStyle?: CSSProperties;
}) {
  return (
    <FloatingChatFab
      onOpen={onOpen}
      running={running}
      dockStyle={dockStyle}
      cornerClassName="absolute bottom-4 right-4 z-30"
    />
  );
}
